import BackgroundImage from "gatsby-background-image"
import { FluidObject } from "gatsby-image"
import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../../components/shared/breakpoints"
import { Spacer } from "../atoms/layout-primitives"
import Text from "../atoms/text"
import VariantContainer from "../atoms/variant-container"
import { BT } from "../styles/blog-typography"

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0px;
  z-index: -1;
  opacity: 0.9;
  background-color: var(--tricorn-black);
  mix-blend-mode: multiply;
  @media (min-width: ${Breakpoints.lg}) {
    border-radius: 4px;
  }
`

const ExploreContainer = styled(BackgroundImage)`
  grid-column: 1/-1;
  padding: 48px 16px;
  box-sizing: border-box;
  overflow: hidden;
  @media (min-width: ${Breakpoints.md}) {
    padding: 48px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 48px 64px;
    border-radius: 4px;
  }
`

interface IExploreButtonsProps {
  title: string
  background: FluidObject
  children: any
}

/**
 * A container for hightlighted buttons with a background image.
 * @param title - the cta title
 * @param background - the background image
 * @param children - the buttons
 */
const ExploreButtons = ({
  title,
  background,
  children: buttons,
}: IExploreButtonsProps) => {
  return (
    <ExploreContainer
      fluid={background}
      backgroundColor={`var(--tricorn-black)`}
    >
      <Text
        as="h2"
        variants={[
          css`
            margin-top: 16px;
            ${BT.sm.h2`400`}
            color: var(--white);
            text-align: center;
          `,
          css`
            margin: 0;
            ${BT.md.h2`400`}
            color: var(--white);
          `,
          css`
            ${BT.lg.h2`400`};
            color: var(--white);
          `,
        ]}
      >
        {title}
      </Text>
      <Spacer height={{ sm: "24px", md: "48px" }} />
      <VariantContainer
        variants={[
          css`
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 0 auto;

            gap: 16px;
            color: var(--white);
            a {
              min-width: 0;
              width: 100%;
              max-width: 156px;
              height: 56px;
              background-color: var(--white);
              border: none;
              border-radius: 4px;
              padding: 16px;
              ${BT.sm.info`500`};
              font-size: 16px;
              letter-spacing: inherit;
              text-transform: none;
              line-height: 1;
              :hover,
              :focus,
              :active {
                background-color: var(--burnt-orange);
                color: var(--white);
              }
              transition: all 0.2s;
            }
          `,
          css`
            max-width: 500px;
          `,
          css`
            max-width: 100%;
          `,
        ]}
      >
        {buttons}
      </VariantContainer>
      <Overlay />
    </ExploreContainer>
  )
}

export default ExploreButtons
